import _ from 'lodash'
import api, { formCfg, listDehydrate } from './api'

export default function apiFactory(url, actions, transformations) {
  const {
    hydrate = _.identity,
    dehydrate = _.identity,
    errorsDehydrate = _.identity,
  } = transformations

  const methods = {
    getList(params, context) {
      const dehydrateFn = transformations.getListDehydrate || dehydrate

      return api
        .get(url, formCfg(params, context))
        .then((response) => listDehydrate(response.data, dehydrateFn))
    },

    getDetail(pk, params, context) {
      const dehydrateFn = transformations.getDetailDehydrate || dehydrate

      return api
        .get(`${url}${pk}/`, formCfg(params, context))
        .then((response) => dehydrateFn(response.data))
    },

    create(data, params, context) {
      const hydrateFn = transformations.createHydrate || hydrate
      const dehydrateFn = transformations.createDehydrate || dehydrate

      return api
        .post(url, hydrateFn(data), formCfg(params, context))
        .catch((error) => {
          throw errorsDehydrate(error.response.data)
        })
        .then((response) => dehydrateFn(response.data))
    },

    update(pk, data, params, context) {
      const hydrateFn = transformations.updateHydrate || hydrate
      const dehydrateFn = transformations.updateDehydrate || dehydrate

      return api
        .put(`${url}${pk}/`, hydrateFn(data), formCfg(params, context))
        .catch((error) => {
          throw errorsDehydrate(error.response.data)
        })
        .then((response) => dehydrateFn(response.data))
    },

    partialUpdate(pk, data, params, context) {
      const hydrateFn = transformations.partialUpdateHydrate || hydrate
      const dehydrateFn = transformations.partialUpdateDehydrate || dehydrate

      return api
        .patch(`${url}${pk}/`, hydrateFn(data), formCfg(params, context))
        .catch((error) => {
          throw errorsDehydrate(error.response.data)
        })
        .then((response) => dehydrateFn(response.data))
    },

    delete(pk, data, params, context) {
      return api
        .delete(`${url}${pk}/`, formCfg(params, context))
        .catch((error) => {
          throw errorsDehydrate(error.response.data)
        })
    },
  }

  return _.pick(methods, actions)
}
